import Graduates from "../assets/graduates.jpg";
import { CTASection } from "../components/CTASection";
import { SEO } from "../components/SEO";

export default function AboutSection() {
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about BeginPack Ltd - a registered company dedicated to providing high-quality study abroad, migration, and flight booking services. Discover our mission, vision, and promise to our clients."
        ogTitle="About BeginPack Ltd - Our Mission, Vision & Values"
        ogDescription="Learn about BeginPack Ltd's mission to empower individuals with seamless access to global opportunities through reliable study abroad guidance and professional services."
      />

      {/* Hero Section */}
      <div className="relative bg-cover bg-center bg-no-repeat py-20 bg-gradient-to-br from-[#004E89] to-[#800020] md:py-28 lg:py-32 mb-16 md:mb-28">
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-['Plus_Jakarta_Sans'] text-xs md:text-sm tracking-widest text-white mb-6 uppercase antialiased">
            WHO WE ARE
          </p>
          <h1 className="font-['Poppins'] text-2xl sm:text-2xl md:text-3xl lg:text-3xl font-bold text-white mx-auto">
            BEGINPACK LTD is a registered company dedicated to providing
            high-quality study abroad, migration, and flight booking services.
            With a commitment to excellence and transparency, we guide
            individuals toward global opportunities and support them at every
            step of their journey.
          </h1>
        </div>
      </div>

      {/* Timeline Container */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Center vertical line - hidden on mobile */}
        <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gray-300 transform -translate-x-1/2"></div>

        {/* Section 1 - Our Mission */}
        <div className="relative mb-20 md:mb-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Image - Left */}
            <div className="lg:pr-12">
              <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3]">
                <img
                  src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800&q=80"
                  alt="Student using phone"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Content - Right */}
            <div className="lg:pl-12">
              <h2 className="font-['Poppins'] text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 tracking-tight antialiased">
                Our Mission
              </h2>
              <p className="font-['Plus_Jakarta_Sans'] text-gray-600 text-base md:text-lg leading-relaxed tracking-tight antialiased">
                To empower individuals with seamless access to global
                opportunities by providing reliable study abroad guidance,
                professional migration services, and convenient flight booking
                solutions.
              </p>
            </div>
          </div>

          {/* Number Badge - Center */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 hidden lg:block">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#004E89] to-[#800020] flex items-center justify-center shadow-xl border-4 border-gray-50">
              <span className="font-['Poppins'] text-white text-2xl font-bold">
                1
              </span>
            </div>
          </div>
        </div>

        {/* Section 2 - Our Vision */}
        <div className="relative mb-20 md:mb-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Content - Left */}
            <div className="lg:pr-12 order-2 lg:order-1">
              <h2 className="font-['Poppins'] text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 tracking-tight antialiased">
                Our Vision
              </h2>
              <p className="font-['Plus_Jakarta_Sans'] text-gray-600 text-base md:text-lg leading-relaxed tracking-tight antialiased">
                To become a trusted leader in international education, migration
                consultancy, and travel services, recognized for excellence,
                integrity, and life-changing support.
              </p>
            </div>

            {/* Image - Right */}
            <div className="lg:pl-12 order-1 lg:order-2">
              <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3]">
                <img
                  src={Graduates}
                  alt="Graduate student"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Number Badge - Center */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 hidden lg:block">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#004E89] to-[#800020] flex items-center justify-center shadow-xl border-4 border-gray-50">
              <span className="font-['Poppins'] text-white text-2xl font-bold">
                2
              </span>
            </div>
          </div>
        </div>

        {/* Section 3 - Our Promise */}
        <div className="relative mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Image - Left */}
            <div className="lg:pr-12">
              <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3]">
                <img
                  src="https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=80"
                  alt="Students laughing together"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Content - Right */}
            <div className="lg:pl-12">
              <h2 className="font-['Poppins'] text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 tracking-tight antialiased">
                Our Promise
              </h2>
              <ul className="font-['Plus_Jakarta_Sans'] text-gray-600 text-base md:text-lg leading-relaxed tracking-tight antialiased space-y-3">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-gradient-to-r from-[#004E89] to-[#800020] rounded-full mr-4 flex-shrink-0"></span>
                  Integrity
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-gradient-to-r from-[#004E89] to-[#800020] rounded-full mr-4 flex-shrink-0"></span>
                  Transparency
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-gradient-to-r from-[#004E89] to-[#800020] rounded-full mr-4 flex-shrink-0"></span>
                  Professionalism
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-gradient-to-r from-[#004E89] to-[#800020] rounded-full mr-4 flex-shrink-0"></span>
                  Commitment
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-gradient-to-r from-[#004E89] to-[#800020] rounded-full mr-4 flex-shrink-0"></span>
                  Customer-Centered Service
                </li>
              </ul>
            </div>
          </div>

          {/* Number Badge - Center */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 hidden lg:block">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#004E89] to-[#800020] flex items-center justify-center shadow-xl border-4 border-gray-50">
              <span className="font-['Poppins'] text-white text-2xl font-bold">
                3
              </span>
            </div>
          </div>
        </div>
      </div>

      <CTASection />
    </>
  );
}
